/**
 * Share codes: a time-limited door onto one work.
 */
import type {
  IssueShareCodeRequest,
  RedeemShareCodeRequest,
  RedeemShareCodeResponse,
  ShareCodesResponse,
} from "@ondo/shared";

import { request } from "./request.ts";

/** The codes the caller issued, their firm issued, or that were issued on a work they own. */
export const fetchShareCodes = () =>
  request<ShareCodesResponse>("/share-codes").then((body) => body.shareCodes);

/** A time-limited door onto one work. The curatable set may issue; see the migration. */
export const issueShareCode = (workId: string, body: IssueShareCodeRequest) =>
  request<{ shareCodeId: string; code: string }>(`/works/${workId}/share-codes`, body);

/** Ends the code and revokes every grant it made, in one statement. */
export const endShareCode = (shareCodeId: string) =>
  request<void>(`/share-codes/${shareCodeId}/end`, {});

/**
 * A guess at a code. 403 for every refusal at once — no such code, expired,
 * ended, already yours — and 429 for a spent budget, which the caller must
 * tell apart: a throttle rendered as "wrong code" would say the opposite of
 * the truth about the guess.
 */
export const redeemShareCode = (body: RedeemShareCodeRequest) =>
  request<RedeemShareCodeResponse>("/share-codes/redeem", body);
